import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import HeaderUser from "../../components/Header/HeaderUser";
import { getUserDetails } from "../../api/viewUserApi";
import "./Viewuser.css";
import { getUserDetailsById, getUserhistory } from "../../api/viewUserApi";

const tableHeadings = {
  "game-history": [
    "Game ID",
    "Game Mode",
    "Play Time",
    "Score",
    "Coin",
    "Date & Time",
  ],
  transactions: [
    "S.No",
    "Transaction ID",
    "Payment Amount",
    "Plan Title",
    "Amount/Coins",
    "Status",
    "Date & Time",
  ],
  "purchased-items": [
    "Snakes",
    "Theme Type",
    "Buying Price",
    "Date & Time",
    "Title Name",
    "Claimed By",
  ],
};

// const infotypeFilters = {
//   gameHistory: ["all", "infinite", "time"],
//   transactions: ["all", "coin", "powerup"],
//   "purchased-items": ["all", "snake", "background", "powerup"],
// };

const infotypeFilters = {
  "game-history": [
    { label: "all", filter: null },
    { label: "infinite", filter: "infinite" },
    { label: "time", filter: "time" },
  ],

  transactions: [
    { label: "all", filter: null },
    { label: "coin", filter: "coin" },
    { label: "powerup", filter: "powerUp" },
  ],

  "purchased-items": [
    { label: "all", filter: null },
    { label: "snake", filter: "snakeSkin" },
    { label: "background", filter: "background" },
    { label: "powerup", filter: "powerUp" },
    { label: "chest", filter: "chest" },
    { label: "coin", filter: "coin" },
  ],
};

const InfoRow = ({ label, value }) => (
  <div className="info-row">
    <span>{label}</span>
    <span>{value ?? "-"}</span>
  </div>
);

const UserProfileCard = ({ user }) => (
  <div className="profile-card">
    <h3>User Information</h3>

    <div className="profile-header">
      <div className="profile-avatar"></div>
      <div className="profile-name">Player {user.name}</div>
      <div className={`profile-status ${user.block ? "inactive" : "active"}`}>
        {user.block ? "Inactive" : "Active"}
      </div>
    </div>

    <InfoRow label="User ID" value={`UID-${user._id}`} />
    <InfoRow label="Age" value={user.age} />
    <InfoRow label="Mobile" value={user.mobilenumber} />
    <InfoRow label="Email" value={user.email} />
    <InfoRow label="Country" value={user.country} />
    <InfoRow label="Joined" value={user.createdAt.split("T")[0]} />
    <InfoRow label="Last Active" value={user.lastActive.split("T")[0]} />
    <InfoRow label="Wallet Balance" value={user.coins} />
  </div>
);

const UserActivity = ({ userId, infotype, setInfotype, filter, setFilter }) => {
  const [activity, setActivity] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;

  const startIndex = (page - 1) * limit;
  const paginatedActivity = activity.slice(startIndex, startIndex + limit);

  useEffect(() => {
    setPage(1);
  }, [infotype, filter]);

  useEffect(() => {
    const fetchActivity = async () => {
      try {
        // const res = await getUserDetails(userId, infotype, filter, page, limit);
        const res = await getUserhistory(userId, infotype, filter, page, limit);
        if (!res.data?.formattedResult || !res?.data?.formattedResult.length) {
          setActivity([]);

          return;
        }

        setActivity(res?.data?.formattedResult || []);
        setTotalPages(res.data?.totalPages || 1);

        // const user = res.data[0];
        // if (infotype === "gameHistory") {
        //   setActivity(user.gameHistory || []);
        //   console.log("res?.formattedResult ", res?.formattedResult);
        // } else if (infotype === "transactions") {

        //   setActivity(res?.data?.formattedResult || []);
        //   console.log(
        //     "res?.data?.formattedResult ",
        //     res?.data?.formattedResult,
        //   );
        // } else setActivity(res.data.formattedResult || []);
      } catch (err) {
        console.error("Failed to fetch activity:", err);
        setActivity([]);
      }
    };

    fetchActivity();
  }, [userId, infotype, filter, page]);

  return (
    <div className="activity-panel">
      <h3>User Activity</h3>

      <div className="tabs">
        {["game-history", "transactions", "purchased-items"].map((type) => (
          <button
            key={type}
            className={`tab-btn ${infotype === type ? "active" : ""}`}
            onClick={() => {
              setInfotype(type);
              // setFilter("all");
              setFilter(null);
            }}
          >
            {type === "game-history"
              ? "Game History"
              : type === "transactions"
                ? "Transactions"
                : "Purchased Items"}
          </button>
        ))}
      </div>

      <div className="filters">
        {infotypeFilters[infotype].map((f) => (
          <button
            key={f.label}
            className={`filter-btn ${filter === f.filter ? "active" : ""}`}
            onClick={() => setFilter(f.filter)}
          >
            {f.label}
          </button>
        ))}
      </div>

      <div className="activity-table-wrapper">
        <table className="activity-table">
          <thead>
            <tr>
              {tableHeadings[infotype].map((h) => (
                <th key={h}>{h}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {activity.length ? (
              activity.map((item, idx) => (
                <tr key={idx}>
                  {tableHeadings[infotype].map((h) => {
                    let value = "-";

                    if (infotype === "game-history") {
                      const map = {
                        "Game ID": item?._id,
                        "Game Mode": item?.mode,
                        "Play Time": item?.duration,
                        Score: item?.score,
                        Coin: item?.coinEarned,
                        "Date & Time":
                          new Date(item?.createdAt).toLocaleString() || "_",
                      };
                      value = map[h];
                    }

                    if (infotype === "transactions") {
                      const map = {
                        "S.No": idx + 1,
                        "Transaction ID": item._id,
                        "Payment Amount": item.price,
                        "Plan Title": item.itemName,
                        "Amount/Coins": item.amount,
                        Status: item.status,
                        "Date & Time": item?.purchasedAt
                          ? item.purchasedAt.split("T")[0]
                          : "_",
                      };
                      value = map[h];
                    }

                    if (infotype === "purchased-items") {
                      const map = {
                        Snakes: item.itemType,
                        "Theme Type": item.itemType,
                        "Buying Price": item.price,
                        "Date & Time":
                          new Date(item?.createdAt).toLocaleString() || "-",
                        "Title Name": item.itemName,
                        "Claimed By": item?.purchasedBy || "_",
                      };
                      value = map[h];
                    }

                    return <td key={h}>{value ?? "-"}</td>;
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={tableHeadings[infotype].length}
                  className="no-data"
                >
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button disabled={page === 1} onClick={() => setPage(page - 1)}>
          Prev
        </button>
        <span>
          Page {page} / {totalPages}
        </span>
        <button
          disabled={page >= totalPages}
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
        >
          Next
        </button>
      </div>
    </div>
  );
};

const UserDetails = () => {
  const { id } = useParams();
  const [profile, setProfile] = useState(null);
  const [infotype, setInfotype] = useState("game-history");
  const [filter, setFilter] = useState(null);

  // useEffect(() => {
  //   const fetchProfile = async () => {
  //     try {
  //       const res = await getUserDetails(id, "gameHistory", "all", 1, 10);
  //       // if (res.data?.length) setProfile(res.data[0]);
  //     } catch (err) {
  //       console.error("Failed to fetch profile:", err);
  //     }
  //   };
  //   fetchProfile();
  // }, [id]);

  const fetchUserDetails = async () => {
    if (!id) return;
    try {
      const res = await getUserDetailsById(id);
      setProfile(res.data);
      console.log("sdfghjklsdfghjkl", res);
    } catch (error) {
      console.error("error on get user details:", error);
    }
  };

  const fetchUserHistory = async () => {
    if (!id) return;
    try {
      // const res = await getUserhistory(id, "game-history", 1, 10);
      const res = await getUserhistory(id, "game-history", null, 1, 10);
      console.log("user history resp:", res);
    } catch (error) {
      console.error("error on get user history:", error);
    }
  };

  useEffect(() => {
    fetchUserDetails();
    fetchUserHistory();
  }, [id]);

  if (!profile) return <p>Loading user details...</p>;

  return (
    <div className="user-details-page">
      <div className="user-main">
        <HeaderUser />

        <div className="user-content">
          <div className="page-title">
            <h1>User Details</h1>
            <h3>Detailed information for {profile.username}</h3>
          </div>

          <div className="user-grid">
            <UserProfileCard user={profile} />
            <UserActivity
              userId={profile._id}
              infotype={infotype}
              setInfotype={setInfotype}
              filter={filter}
              setFilter={setFilter}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
